import * as React from 'react';
import * as redux from 'redux';
import { connect } from 'react-redux';

import { IZAplState } from "../../zcommon/contracts";
import { Actions as ZComunicacionesActions } from "../../zcomunicaciones";

import {
    OwnProps,
    ConnectedState,
    ConnectedDispatch,
    ZSesionExpirada,
} from '../components/ZSesionExpirada';

const mapStateToProps = (appState: IZAplState): ConnectedState => ({
    show: appState.sesionExpirada,
    azenURL: appState.azenURL
});

const mapDispatchToProps = (dispatch: redux.Dispatch<any>): ConnectedDispatch => ({
    onSesionExpirada: () => dispatch(ZComunicacionesActions.setSesionExpirada(true))
});

export const ZSesionExpiradaContainer: React.ComponentClass<OwnProps> =
    connect<ConnectedState, ConnectedDispatch, OwnProps>(mapStateToProps, mapDispatchToProps)(ZSesionExpirada);



// WEBPACK FOOTER //
// ./src/modules/zaplicacion/containers/ZSesionExpiradaContainer.tsx